import { cn } from '@repo/ui/lib/cn';

interface LogoTextProps {
  className?: string;
  inheritWeight?: boolean;
}

export function LogoText({ className, inheritWeight = false }: LogoTextProps) {
  return (
    <span className={cn('inline', className)}>
      <span className={cn('text-secondary', !inheritWeight && 'font-light')}>
        eu
      </span>
      <span className={cn('text-primary', !inheritWeight && 'font-medium')}>
        mimo
      </span>
    </span>
  );
}
